import { useEffect, useState } from "react"
import { PanelLoader } from "../../../../features/ui"
import { BookmarkButton } from "../../../../features/bookmarks"
import { RoutePath } from "../../../../features/routes"
import { useManagerHooks } from "../../../manager"
import { ShipmentPreparationList } from "./shipmentPreparationList"
import { DeliveryRoadmap, Roadmap, useRoadmapLoaders } from "../../../logistics"
import { PreparationStatus } from "../../../common"
import { dedupe } from "../../../../utils/listUtils"
import { Delivery, DeliveryOrder, useDeliveryLoaders, useDeliveryOrderLoaders } from "../../../deliveries"

export const ShipmentPreparationListLoader = () => {
    const [roadmaps, setRoadmaps] = useState<Roadmap[]>([])
    const [deliveryRoadmaps, setDeliveryRoadmaps] = useState<DeliveryRoadmap[]>([])
    const [shipments, setShipments] = useState<Delivery[]>([])
    const [shipmentOrders, setShipmentOrders] = useState<DeliveryOrder[]>([])
    const [ready, setReady] = useState(false)
    
    const { currentBranchId } = useManagerHooks()
    const roadmapLoaders = useRoadmapLoaders()
    const deliveryLoaders = useDeliveryLoaders()
    const deliveryOrderLoaders = useDeliveryOrderLoaders()

    const load = async () => {
        const { loadBranchRoadmaps, loadRoadmapsDeliveriesLinks } = roadmapLoaders()
        let loadedRoadmaps = await loadBranchRoadmaps(currentBranchId!)
        loadedRoadmaps = loadedRoadmaps.filter(roadmap =>
            roadmap.preparationStatus === PreparationStatus.PENDING ||
            new Date(roadmap.date).toDateString() === new Date().toDateString()
        )
        let loadedDeliveryRoadmaps = await loadRoadmapsDeliveriesLinks(loadedRoadmaps.map(roadmap => roadmap.id), true)
        const { loadDeliveries } = deliveryLoaders()
        const deliveryIds = dedupe(loadedDeliveryRoadmaps.map(deliveryRoadmap => deliveryRoadmap.deliveryId))
        const loadedDeliveries = await loadDeliveries(deliveryIds)
        const { loadDeliveryOrders } = deliveryOrderLoaders()
        const loadedDeliveryOrders = await loadDeliveryOrders(loadedDeliveries.map(delivery => delivery.orderId!))
        loadedDeliveryRoadmaps = loadedDeliveryRoadmaps.filter(deliveryRoadmap => loadedDeliveries.some(delivery => delivery.id === deliveryRoadmap.deliveryId))
        loadedRoadmaps = loadedRoadmaps.filter(roadmap => loadedDeliveryRoadmaps.some(deliveryRoadmap => deliveryRoadmap.roadmapId === roadmap.id))
        setRoadmaps(loadedRoadmaps)
        setDeliveryRoadmaps(loadedDeliveryRoadmaps)
        setShipments(loadedDeliveries)
        setShipmentOrders(loadedDeliveryOrders)
    }

    useEffect(() => {
        setReady(false)
        load().then(() => setReady(true))
    }, [currentBranchId])

    return (
        <PanelLoader
            title="Preparación de Envíos"
            ready={ready}
            wide
            titleRight={<BookmarkButton routePath={RoutePath.SHIPMENT_PREPARATION} />}
        >
            <ShipmentPreparationList
                roadmaps={roadmaps}
                deliveryRoadmaps={deliveryRoadmaps}
                shipments={shipments}
                shipmentOrders={shipmentOrders}
            />
        </PanelLoader>
    )
}
